// Grid geometry, shared by the timeline view and the bars it renders.
//
// Day/row sizing follows the planner mockup's rhythm, pulled in a bit: the
// mockup breathes partly because it was drawn with a dozen fake vehicles, and
// production runs 136 — its literal 440/60 would put ~12 rows and 3 days on
// screen and turn a fleet overview into scrolling.
export const DAY_WIDTH = 320
export const ROW_MIN_HEIGHT = 46
// Wide enough for the plate plus a "driver · N zleceń" subtitle without the
// count truncating away; the mockup runs ~220.
export const DRIVER_COLUMN_WIDTH = 200
export const BAR_HEIGHT = 28
export const LANE_SPACING = 31
export const ROW_PADDING_Y = 6
export const HOUR_TICKS = [0, 3, 6, 9, 12, 15, 18, 21]
export const DAY_IN_MS = 24 * 60 * 60 * 1000
